import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import ImagePicker from "@/components/admin/ImagePicker";
import { toast } from "sonner";

function PageHeader({ title, desc }) {
  return (
    <div className="mb-8">
      <div className="text-xs uppercase tracking-[0.22em] text-sage-600">Edit</div>
      <h1 className="font-serif text-4xl text-earth-900 mt-2 font-light">{title}</h1>
      {desc && <p className="text-earth-600 mt-2">{desc}</p>}
    </div>
  );
}

export default function HeroManager() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/hero").then((r) => setData(r.data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/content/hero", data);
      toast.success("Hero updated");
    } catch {
      toast.error("Could not save");
    } finally {
      setSaving(false);
    }
  };

  if (!data) return <div className="text-earth-600">Loading…</div>;

  return (
    <div data-testid="hero-manager">
      <PageHeader title="Hero Section" desc="The first thing visitors see." />
      <div className="bg-white rounded-2xl p-8 border border-earth-100 flex flex-col gap-5">
        <div>
          <Label>Eyebrow / tagline</Label>
          <Input className="mt-2" value={data.eyebrow || ""} onChange={(e) => setData({ ...data, eyebrow: e.target.value })} data-testid="hero-eyebrow" />
        </div>
        <div>
          <Label>Heading</Label>
          <Input className="mt-2" value={data.heading || ""} onChange={(e) => setData({ ...data, heading: e.target.value })} data-testid="hero-heading" />
        </div>
        <div>
          <Label>Subheading</Label>
          <Textarea className="mt-2" rows={3} value={data.subheading || ""} onChange={(e) => setData({ ...data, subheading: e.target.value })} data-testid="hero-subheading" />
        </div>
        <div>
          <Label>CTA text</Label>
          <Input className="mt-2" value={data.cta_text || ""} onChange={(e) => setData({ ...data, cta_text: e.target.value })} data-testid="hero-cta" />
        </div>
        <ImagePicker
          label="Background image"
          value={data.background_image}
          onChange={(v) => setData({ ...data, background_image: v })}
          testId="hero-bg"
          aspect="aspect-[16/7]"
        />
        <div>
          <Button onClick={save} disabled={saving} className="bg-earth-900 text-white hover:bg-earth-800 rounded-full px-8" data-testid="hero-save-btn">
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </div>
      </div>
    </div>
  );
}
